var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("el-alert", {
        attrs: {
          title:
            "由于演示功能特殊，请注意在需要时刷新您的浏览器（以重置路由设置）查看效果",
          type: "warning",
          "show-icon": ""
        }
      }),
      _c("d2-highlight", { attrs: { code: _vm.dataView } }),
      _c(
        "el-form",
        { attrs: { "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "创建路由（你可以假设上面是接口数据）" } },
            [
              _c(
                "el-button-group",
                _vm._l(_vm.setting, function(item) {
                  return _c(
                    "el-button",
                    {
                      key: item.component,
                      on: {
                        click: function($event) {
                          return _vm.onClick(item)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(item.title) + " ")]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }